import { render } from "./PeriodeFilter.vue?vue&type=template&id=0831ab24&ts=true"
import script from "./PeriodeFilter.vue?vue&type=script&lang=ts"
export * from "./PeriodeFilter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__